var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center text-center leading-none mt-8"},[_c('button',{staticClass:"border-black border-2 py-3 px-8 bg-herored text-white",on:{"click":function($event){return _vm.open()}}},[_vm._v(" Sign In ")])])}
var staticRenderFns = []

export { render, staticRenderFns }